// Service page content for Employer Nomination Scheme (Subclass 186).
// Sourced from docs/research/australian-visa-pathways.md §2.
// COMPLIANCE: we are not a registered migration agent and do not give migration
// advice or assess eligibility; the regulated advice and lodgement are a
// registered migration agent's. No guaranteed outcomes; honest about processing
// realities without quoting unverified figures as fact. "Who does what"
// disclosure and disclaimer are rendered by the shared page template.

const employerNomination186 = {
  groupSlug: "employer-sponsored",
  slug: "employer-nomination-186",
  title: "Employer Nomination Scheme visa (Subclass 186)",
  eyebrow: "Employer Sponsored",
  intro:
    "The Subclass 186 is a permanent residence visa for skilled workers nominated by an Australian employer for an ongoing position. It is the main employer-sponsored route to permanent residence, whether you are transitioning from a 482 or applying directly with the right skills and experience.",

  chips: [
    { label: "Visa type", value: "Permanent residence" },
    { label: "Sponsor", value: "Australian employer" },
    { label: "Streams", value: "Temporary Residence Transition, Direct Entry" },
    { label: "Skills assessment", value: "Often required (Direct Entry)" },
  ],

  whoFor: [
    "482 or legacy 457 holders who have worked for their sponsor long enough to transition.",
    "Skilled workers with an employer ready to nominate them for a permanent role.",
    "People who want permanent residence on grant rather than a temporary visa first.",
  ],

  essentials: [
    {
      title: "An employer nomination",
      detail:
        "An approved Australian employer must nominate you for a genuine, ongoing position.",
    },
    {
      title: "The right stream",
      detail:
        "The Temporary Residence Transition stream is for those who have worked for the sponsor on a 482 or 457 for the required period. The Direct Entry stream is for those applying without that temporary history.",
    },
    {
      title: "Skills and experience",
      detail:
        "Direct Entry generally requires a positive skills assessment and several years of relevant experience. The occupation must be on the applicable list.",
    },
    {
      title: "Under 45 at application",
      detail:
        "An age limit applies, with exemptions for some high earners, academics, researchers, and long-term temporary-visa holders.",
    },
    {
      title: "English, health, and character",
      detail:
        "Standard English, health, and character requirements apply to you and any family included.",
    },
  ],

  process: [
    {
      title: "Confirm your stream",
      detail:
        "A registered migration agent works out whether Temporary Residence Transition or Direct Entry is your path, and what each needs. We organise the documents behind it.",
    },
    {
      title: "Skills assessment if needed",
      detail:
        "For Direct Entry, we help you assemble and prepare the evidence for a positive skills assessment for your occupation.",
    },
    {
      title: "Prepare the employer nomination",
      detail:
        "We help the employer organise the nomination paperwork, and a registered migration agent advises on their obligations.",
    },
    {
      title: "Lodge the visa application",
      detail:
        "We prepare a thorough file. A registered migration agent lodges the application and deals with the Department.",
    },
    {
      title: "Decision",
      detail:
        "The Department decides. If granted, the 186 is permanent residence from the start.",
    },
  ],

  faqs: [
    {
      q: "What is the difference between the two streams?",
      a: "Temporary Residence Transition is for people who have already worked for their sponsoring employer on a 482 or 457 for the required period. Direct Entry is for those applying without that history, and it usually needs a skills assessment and several years of experience.",
    },
    {
      q: "How long does the 186 take?",
      a: "Processing times are set by the Department and have been long for Direct Entry in recent periods. Priority is often given to regional, healthcare, teaching, and accredited-sponsor cases. A registered migration agent gives you a realistic, current timeframe for your situation rather than a best-case promise.",
    },
    {
      q: "Do I need a skills assessment?",
      a: "Usually yes for Direct Entry, and sometimes for Temporary Residence Transition depending on your occupation. A registered migration agent confirms what your case requires before you start.",
    },
    {
      q: "Can my time on a 482 count toward this visa?",
      a: "Yes. Time working for your sponsor on a 482 in the nominated occupation generally counts toward the Temporary Residence Transition requirement. A registered migration agent helps you plan the timing, and we keep your records in order for it.",
    },
  ],

  related: ["skills-in-demand-482", "regional-494", "skills-assessment"],

  lastVerified: "13 July 2026",
};

export default employerNomination186;
